import {createSelector} from 'reselect'

import type {State} from '../../../reducers/types'
import {getProjectsHash, getStatus} from '../../../selectors'
import type {Branch} from '../../../services/rest'
import {getBuildTypeStatusRequest} from '../../../types'
import type {BuildTypeId, Investigation, ProjectId} from '../../../types'

import {getEntityInCurrentScope} from './Investigations.utils'

export const getIsBuildTypeFailure: (
  state: State,
  buildTypeId: BuildTypeId | null | undefined,
  branch: Branch | null | undefined,
) => boolean | null | undefined = (state, buildTypeId, branch) => {
  if (buildTypeId != null) {
    const ownStatusRequest = getBuildTypeStatusRequest(buildTypeId, branch)
    return getStatus(state, ownStatusRequest)?.status === 'FAILURE'
  }

  return null
}

export const getInvestigationInCurrentScope: (
  state: State,
  investigations: readonly Investigation[],
  projectId?: ProjectId | null,
  buildTypeId?: BuildTypeId | null,
) => Investigation | null = createSelector(
  [
    getProjectsHash,
    (_: State, investigations: readonly Investigation[]) => investigations,
    (_: State, __: readonly Investigation[], projectId?: ProjectId | null) => projectId,
    (
      _: State,
      __: readonly Investigation[],
      ___?: ProjectId | null,
      buildTypeId?: BuildTypeId | null,
    ) => buildTypeId,
  ],
  (projectsHash, investigations, projectId, buildTypeId) =>
    getEntityInCurrentScope(projectsHash, investigations, projectId, buildTypeId),
)
